export default (
  state = {
    skus: []
  },
  action
) => {
  switch (action.type) {
    case 'REMOVE_ITEM_FROM_CART':
      return { skus: [ ...state.skus, action.sku ] }
    case 'REMOVE_ITEM_FROM_CART_SUCCESS':
    case 'REMOVE_ITEM_FROM_CART_FAIL':
      state.skus = state.skus.filter(item => item !== action.sku)
      return state
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/Checkout/Cart/reducer.js